export const toggleLoading = () => dispatch => {
  dispatch({
    type: 'TOGGLE_LOADING',
  });
};
